import angular from "angular";

angular
    .module('app')
    .component('courseCheckoutForm', {
        template: require('./course-checkout-form.html'),
        controller: ['$http', '$timeout', 'Auth', '$sce', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, $timeout, Auth, $sce) {

    let $ctrl = this;

    $ctrl.$onInit = function () {

        console.log($ctrl.user);
        console.log($ctrl.resolve);
        return;

        $ctrl.user = Auth.user();

        $ctrl.email = $ctrl.user.email;

        $ctrl.course = $ctrl.resolve.course;

        $ctrl.openGroup = $ctrl.course.groups[0];

        $ctrl.hasGroupSale = !!$ctrl.openGroup;
        $ctrl.hasSingleSale = !!$ctrl.course.open_single_sales;

        $ctrl.selectedType = $ctrl.openGroup ? 'group' : 'single';
    };

    $ctrl.buy = function () {

        $ctrl.loading = true;

        $http
            .post(`/courses/${$ctrl.course.id}/buy`, {type: $ctrl.selectedType})
            .then(
                function (response) {

                    $ctrl.loading = false;

                    $ctrl.orderId = response.data.orderId;
                    $ctrl.url = $sce.trustAsResourceUrl(response.data.url);
                    $ctrl.sign = response.data.sign;
                    $ctrl.backlink = response.data.backlink;
                    $ctrl.failureBackLink = response.data.failureBackLink;
                    $ctrl.postLink = response.data.postLink;
                    $ctrl.failurePostLink = response.data.failurePostLink;

                    $timeout(function () {
                        document.getElementById('payment-form-button').click();
                    }, 500);

                },
                function (error) {
                    $ctrl.loading = false;
                    alert(error.data.message);
                }
            );
    };
}
